// extracted by mini-css-extract-plugin
export default {"overlay":"Ft-z","bodyOpen":"Gt-z","content":"Ht-z","header":"It-z","close":"Jt-z","closeNoHeading":"Kt-z"};